<template>
  <div class="">
    <div v-show="currentJob.state === 'processing'" class="mh-100 h-100">
      <div v-if="currentNumberOfImages === 1" class="gallery-1-mobile p-20 justify-content-center loading">
        <div class="gallery-row-mobile">
          <div class="mobile-image">
            <img :src="loadingImage">
          </div>
        </div>
      </div>
      <div v-else class="gallery-multiple-mobile p-20 loading">
        <div class="gallery-row-mobile">
          <div v-for="index in currentNumberOfImages" class="mobile-image">
            <img :src="loadingImage">
          </div>
        </div>
      </div>
    </div>
    <div v-show="currentJob.state === 'completed'" class="mh-100 h-100">
      <div v-if="currentNumberOfImages === 1" class="gallery-1-mobile justify-content-center p-20" ref="galleryMobile">
        <div class="mobile-image"><img :src="currentJob.base64_output_images[0]"></div>
      </div>
      <div v-else class="gallery-multiple-mobile p-20" ref="galleryMobile">
        <div v-for="(output, index) in currentJob.base64_output_images" :key="index" class="mobile-image result-img">
          <router-link v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'SelectedImageCanvas', params: { uuid: id, selected_image: index } }">
            <img :src="output"  @click="navigate">
          </router-link>
        </div>
      </div>
    </div>

    <div class="sidebar-item">
      <job-queued></job-queued>
    </div>
    <div class="sidebar-item">
      <continue-with></continue-with>
    </div>
    <div class="sidebar-item feedback-item feedback-item-bg">
      <feedback></feedback>
    </div>
    <div class="sidebar-item">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold d-flex gap-10 align-items-center">  <i class="far fa-images"></i> {{ 'Creations' | trans }}</div>
        <div class="text-muted font-weight-bold"></div>
      </div>
    </div>
    <creations></creations>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import ContinueWith from "../Elements/ContinueWith.vue";
import Feedback from "../Elements/Feedback.vue";
import ExportBtn from "../Elements/ExportBtn.vue";
import Creations from "../Elements/Creations.vue";
import ImagesManager from "../../manager/ImagesManager";
import AspectRatioManager from "../../manager/AspectRatioManager";
import JobQueued from "../Elements/JobQueued.vue";

export default {
  name: "MobileResult",
  props: {},
  components: {JobQueued, ExportBtn, ContinueWith, Feedback, Creations },
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {
    loadingImage() {
      let aspectRatio = AspectRatioManager.getBySize(this.currentJob.settings.conversion.options.aspect_ratio);

      if (!aspectRatio.loading) {
        return '';
      }

      return aspectRatio.loading;
    },
    currentNumberOfImages() {
      const { batch_size, batch_count } = this.creatorStudio.settings.conversion.options;

      return ImagesManager.getByBatchSizeAndCount(batch_size, batch_count).number;
    }
  }
};
</script>
<style lang="scss">
.gallery-1-mobile {
  display: flex;
  gap: 20px;
  height: 240px;

  img {
    object-fit: contain;
    max-height: 200px;
  }
}

.gallery-multiple-mobile {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  overflow-x: scroll;
  height: 260px;

  img {
    width: auto;
    max-width: 239px!important;
    object-fit: contain;
    max-height: 200px;
  }
}

.gallery-row-mobile {
  display: flex;
  align-items: center;
  gap: 20px;
}

.mobile-image {
  object-fit: contain;
}

.export-mobile {
  border-top: 1px solid #595959;
}

.loading,
.loading h4,
.loading .description {
  img {
    background-color: #383838;
    background: linear-gradient(
            100deg,
            rgba(255, 255, 255, 0) 40%,
            rgba(255, 255, 255, .1) 50%,
            rgba(255, 255, 255, 0) 60%
    ) #383838;
    background-size: 200% 100%;
    background-position-x: 180%;
    animation: 1s loading ease-in-out infinite;
  }
}

.sidebar-right-bot {
  flex: 1 1 auto;
  overflow-y: auto;
  background: #2c2c2c;
  color: #fff;
}

@keyframes loading {
  to {
    background-position-x: -20%;
  }
}
</style>
